import { Grid, TextField } from "@mui/material";
import * as React from "react";
import { DialogSectionCard } from "source/components/framework/Dialog/DialogSectionCard";
import { TextFieldWithButtonGroup } from "source/components/framework/Form/TextFieldWithButtonGroup";
import { Translations } from "ui/Scripts/source/models/translations";
import { ICompanyListItem } from "../../../../models/company/companyListItem";
import { IFileFilterListItem } from "../../../../models/fileFilter/fileFilterListItem";
import { IMessageTypeListItem } from "../../../../models/messageType/messageTypeListItem";
import { FormField } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../../framework/Grid/GridRow";
import { CompanyEditNewCompanyFileFilterList } from "./CompanyEditNewCompanyFileFilterList";
import { CompanyEditNewCompanyMessageTypeList } from "./CompanyEditNewCompanyMessageTypeList";
import { SelectCompanyDialog } from "../../SelectCompanyDialog/SelectCompanyDialog";

export interface ICompanyEditNewCompanyProp {
    fileFilters: IFileFilterListItem[];
    messageTypes: IMessageTypeListItem[];
    //Administrator
    administratorCode: string;
    administratorFirstName: string;
    administratorLastName: string;
    administratorPassword: string;
    //Copy Documents
    copyDocumentsFromCompanyCode: string;
    //FileFilters
    fileFilterIds: string[];
    //MessageTypes
    messageTypeIds: string[];
    onChange: (name: string, value: string) => void;
    onSetMessageTypeIds: (ids: string[]) => void;
    onSetFileFilterIds: (ids: string[]) => void;
}

export interface ICompanyEditNewCompanyState {
    showSelectCompanyDialog: boolean;
}

export class CompanyEditNewCompany extends React.Component<ICompanyEditNewCompanyProp, ICompanyEditNewCompanyState> {
    constructor(props: ICompanyEditNewCompanyProp) {
        super(props);
        this.state = {
            showSelectCompanyDialog: false
        };
    }

    handleChange = (event) => {
        const target = event.target;
        this.props.onChange(target.name === "xtsss" ? "administratorCode" : (target.name === "n_p_ssas" ? "administratorPassword" : target.name), target.value);
    };

    handleSelectCompany = () => {
        this.setState({
            showSelectCompanyDialog: true
        });
    };

    handleClearCompany = () => {
        this.props.onChange("copyDocumentsFromCompanyCode", "");
    };

    onSelectCompanyDialogOk = async (companies: ICompanyListItem[]) => {
        if (!companies || companies.length < 1) return;
        this.setState({
            showSelectCompanyDialog: false
        });
        this.props.onChange("copyDocumentsFromCompanyCode", companies[0].code);
    };

    onSelectCompanyDialogCancel = () => {
        this.setState({
            showSelectCompanyDialog: false
        });
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <>
                <GridRow sx={{ height: "100%" }}>
                    <Grid item sm={12} md={4} sx={{ display: "flex", flexDirection: "column" }}>
                        <DialogSectionCard headerTitle={Translations.Administrator} height="auto">
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.UserName} required margin={0}>
                                        <TextField type="text" name="xtsss" title={Translations.UserName} inputProps={{ maxLength: 50 }} disabled={false} value={props.administratorCode} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Password} required>
                                        <TextField type="password" name="n_p_ssas" autoComplete="new-password" title={Translations.Password} inputProps={{ maxLength: 50 }} disabled={false} value={props.administratorPassword} required={true} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.FirstName}>
                                        <TextField type="text" name="administratorFirstName" title={Translations.FirstName} inputProps={{ maxLength: 50 }} disabled={false} value={props.administratorFirstName} required={true} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.LastName}>
                                        <TextField type="text" name="administratorLastName" title={Translations.LastName} inputProps={{ maxLength: 50 }} disabled={false} value={props.administratorLastName} required={true} onChange={this.handleChange} />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </DialogSectionCard>
                        <DialogSectionCard headerTitle={Translations.CopyDocumentsFromCompany} height="auto" margin="1rem 0 0 0" flexGrow={2}>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Company} margin={0}>
                                        <TextFieldWithButtonGroup
                                            name="copyDocumentsFromCompanyCode"
                                            title={Translations.Company}
                                            inputProps={{ maxLength: 50 }}
                                            value={props.copyDocumentsFromCompanyCode}
                                            onChange={this.handleChange}
                                            buttons={[
                                                { label: Translations.Select, onClick: this.handleSelectCompany },
                                                { label: Translations.Clear, onClick: this.handleClearCompany },
                                            ]}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </DialogSectionCard>
                    </Grid>
                    <Grid item sm={12} md={4}>
                        <DialogSectionCard headerTitle={Translations.MessageTypes}>
                            <CompanyEditNewCompanyMessageTypeList
                                items={props.messageTypes}
                                checkedIds={props.messageTypeIds}
                                onSetCheckedIds={props.onSetMessageTypeIds}
                            />
                        </DialogSectionCard>
                    </Grid>
                    <Grid item sm={12} md={4}>
                        <DialogSectionCard headerTitle={Translations.FileFilters}>
                            <CompanyEditNewCompanyFileFilterList
                                items={props.fileFilters}
                                checkedIds={props.fileFilterIds}
                                onSetCheckedIds={props.onSetFileFilterIds}
                            />
                        </DialogSectionCard>
                    </Grid>
                </GridRow>
                {state.showSelectCompanyDialog &&
                    <SelectCompanyDialog
                        onOk={this.onSelectCompanyDialogOk}
                        onCancel={this.onSelectCompanyDialogCancel}
                    />
                }
            </>
        );
    }
}